<template>
  <div class="conmon-top micro-page-add">
      <!--第一步-->
      <div v-if="firstContent === true" class="main-content">
        <div class="right-show">
          <div class="phone-content">
            <div class="show-content">
              <!--顶部标题设置-->
              <div class="top-title">
                <div>
                  <span v-if="titleName === ''">点击更改页面标题</span>
                  <el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">
                    <span v-if="titleName !== ''" style="display: inline-block;">{{ titleName }}</span>
                  </el-tooltip>
                </div>
              </div>
              <!--图片设置-->
              <el-upload
                class="avatar-uploader-phone"
                name="file_upload"
                :action="uploadURL"
                title="可以点击图片进行换图"
                :show-file-list="false"
                disabled
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="phoneImg" :src="phoneImg" class="useNowPhoneImg">
                <img v-if="phoneImg === ''" src="../../assets/images/add-img.png" alt="" class="defaultPhoneImg">
              </el-upload>
              <!--添加的属性内容-->
              <div class="add-attr-content">
                <div class="attr-phone-item" v-for="(item, index) in attrPhoneArray" :key="index">
                  <el-input v-if="item.type=='input'" disabled v-model="item.val" :placeholder="item.label"></el-input>
                  <el-select v-if="item.type=='select'" disabled v-model="item.val" :placeholder="item.label">
                    <el-option v-for="(one,i) in option" :key="i" :label="one" :value="one"></el-option>
                  </el-select>
                  <el-input v-if="item.type=='number'" type="number" disabled v-model="item.val" :placeholder="item.label"></el-input>
                  <el-input v-if="item.type=='model'" disabled v-model="item.val" :placeholder="item.label"></el-input>
                  <!--radio转为select-->
                  <div v-if="item.type=='radio'" class="radio-name">{{ item.name }}</div>
                  <el-radio-group class="radio-content" v-if="item.type=='radio'" disabled v-model="item.val" :placeholder="item.label">
                    <el-radio v-for="(one,i) in item.option" :key="i" :label="one">{{ one }}</el-radio>
                  </el-radio-group>
                  <el-input
                    v-if="item.type=='textarea'"
                    type="textarea"
                    disabled
                    autosize
                    :placeholder="item.label"
                    v-model="item.val">
                  </el-input>
                  <!--checkbox-->
                  <div v-if="item.type=='checkBox'" class="checkbox-name">{{ item.name }}</div>
                  <el-checkbox-group v-if="item.type=='checkBox'" v-model="item.val">
                    <el-checkbox disabled v-for="(one, i) in item.option" :key="i" :label="one"></el-checkbox>
                  </el-checkbox-group>
                  <el-date-picker
                    class="date-style"
                    v-if="item.type=='datePicker'"
                    v-model="item.val"
                    type="date"
                    disabled
                    value-format="yyyy-MM-dd"
                    :placeholder="item.label">
                  </el-date-picker>
                  <el-date-picker
                    class="date-style"
                    v-if="item.type=='dateTimePicker'"
                    v-model="item.val"
                    type="datetime"
                    disabled
                    value-format="yyyy-MM-dd"
                    :placeholder="item.label">
                  </el-date-picker>
                  <el-select
                    v-if="item.type=='addressPicker'"
                    :options="addressOptions"
                    disabled
                    :placeholder="item.label"
                    v-model="item.val">
                  </el-select>
                  <div class="ele-div" v-if="item.type==='div'" v-html="item.option"></div>
                  <!--鼠标划上去蒙层-->
                  <div class="item-model" v-if="item.itemShowModel === true">
                    <div @click="deleteAttrItemPhone(item, index)">
                      <i class="iconfont icon-shanchu"></i>
                      <span>删除</span>
                    </div>
                    <div @click="setMustWrite(item)">
                      <i style="font-size: 36px;padding-top: 10px;height: 10px">*</i>
                      <span>必填</span>
                    </div>
                  </div>
                  <!--必填星号-->
                  <div class="must-write" v-if="item.itemMustWrite === true || item.is_require === 1">*</div>
                </div>
                <!--提交按钮-->
                <div class="submit-btn">提交</div>
              </div>
            </div>
          </div>
          <el-button class="next-step-btn" @click="firstToSecond" style="margin: 20px auto;float: none">下一步</el-button>
        </div>
      </div>
      <!--第二步-->
      <div v-if="secondContent === true" class="second-content" style="margin-top: 20px; background-color: #fff; overflow-y: hidden;">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <!-- <el-form-item label="关联公众号:" prop="bindPublic">
            <el-select disabled v-model="ruleForm.bindPublic" placeholder="请关联公众号">
              <el-option
                v-for="item in publics"
                :key="item.id"
                :label="item.nick_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="内部名称:" prop="admin_title">
            <el-input disabled type="input" placeholder="请输入内部名称，客户不可见" maxlength="50" v-model="ruleForm.admin_title"></el-input>
          </el-form-item>
          <el-form-item label="权限设置:" prop="canDo">
            <el-checkbox-group disabled @change="knows" v-model="ruleForm.canDo">
              <!--<el-checkbox label="只能在微信打开" name="canDo" style="margin-left: 0"></el-checkbox>-->
              <el-checkbox label="禁止分享" name="canDo" style="margin-left: 0"></el-checkbox>
              <el-checkbox label="访问页面时请求授权" name="canDo" style="margin-left: 0"></el-checkbox>
              <el-checkbox label="每个用户限填一次" name="canDo" style="margin-left: 0"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="提交限制:" prop="submitLimit">
            <el-input disabled placeholder="0不限制，大于0时限制" v-model.number="ruleForm.submitLimit"></el-input>
          </el-form-item>
          <el-form-item label="标签:" class="picture-text-item">
            <div class="tags-content-look">
              <span class="tag-span-look" v-for="(item, index) in tagsArray" :key="index">
                {{ item }}
              </span>
            </div>
          </el-form-item>
          <el-form-item label="手机验证:" class="isMobileCode" prop="isVerifyMobile">
            <el-radio-group disabled v-model="ruleForm.isVerifyMobile" style="margin-top: 0">
              <el-radio :label="1" style="margin-left: 0;">是</el-radio>
              <el-radio :label="0" style="margin-left: 10px;">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="跳转链接:" prop="link">
            <el-input disabled type="input" placeholder="请输入提交成功后的跳转链接" v-model="ruleForm.link"></el-input>
          </el-form-item>
          <el-form-item label="成功提示:" prop="tips">
            <el-input disabled type="input" placeholder="请输入提交成功后的提示" v-model="ruleForm.tips"></el-input>
          </el-form-item>
          <el-form-item label="客户来源:" prop="customerSource">
            <el-select disabled v-model="ruleForm.customerSource" placeholder="请选择客户来源">
              <el-option
                v-for="item in sources"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="来源说明" prop="sourceDesc">
            <el-input disabled type="textarea" v-model="ruleForm.sourceDesc"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="next-step-btn" @click="toFirst">上一步</el-button>
            <!-- <el-button type="primary" style="margin-top: 3px" @click="toThird">下一步</el-button> -->
          </el-form-item>
        </el-form>
      </div>
      <!--第三步-->
      <div v-if="thirdContent === true" class="third-content">
        <div class="publish-save-content">
          <div class="operation-tips">操作提示</div>
          <p style="margin-top: 30px;margin-bottom: 20px">保存为草稿状态或发布状态？</p>
          <div class="operation-content">
            <el-button disabled type="primary" @click="save" style="float: none">保存</el-button>
            <el-button disabled type="primary" @click="publish" style="float: none;background: #FCA531;border: 1px solid #FCA531;">发布</el-button>
          </div>
        </div>
        <div class="bottom-pre">
          <el-button @click="thirdToSecond">上一步</el-button>
        </div>
      </div>
    <!--修改标题弹窗-->
    <el-dialog class="cellDialog" title="修改页面标题" :visible.sync="editTitleDialog" width="400px">
      <el-form>
        <el-form-item label="标题名称" label-width="80px">
          <el-input v-model="titleName" placeholder="请输入标题名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editTitleDialog = false">取 消</el-button>
        <el-button type="primary" @click="editTitleDialog = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { API_HOST } from '@/api/local'
import { getCustomerAttributeList, editWePage, getWechatPublicListAll, getCustomerSourceListForWepage, getWePageDetail } from '@/api/customer.js'
import { getCusAttrList } from '@/api/set.js'
import { regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import tagsTemplate from '@/components/common/tags-template'
export default {
  name: 'weixinManage',
  data () {
    return {
      rules: {
        admin_title: [
          { required: true, message: '请输入后台标题', trigger: 'blur' }
        ],
        bindPublic: [
          { required: true, message: '请选择关联的公众号', trigger: 'blur' }
        ],
        customerSource: [
          { required: true, message: '请选择客户来源', trigger: 'change' }
        ],
        isVerifyMobile: [
          { required: true, message: '请选择是否手机验证', trigger: 'blur' }
        ],
        link: [
          { type: 'url', message: '请填写正确的跳转链接', trigger: 'blur' }
        ],
        sourceDesc: [
          { required: true, message: '请填写来源说明', trigger: 'blur' }
        ]
      },
      tagsArray: [],
      isAttr: true,
      ruleForm: {
        bindPublic: '',
        admin_title: '',
        link: '',
        tips: '',
        canDo: [],
        customerSource: '',
        sourceDesc: '',
        isVerifyMobile: 0
      },
      publics: [],
      sources: [],
      attrs: [],
      phoneImg: '',
      editTitleDialog: false,
      titleName: '',
      attrPhoneArrayCoby: [],
      attrPhoneArray: [],
      option: [],
      addressOptions: regionDataPlus,
      secondContent: false,
      firstContent: true,
      thirdContent: false,
      wechat_only: 0,
      authorization: 0,
      is_once: 0,
      is_share: 0
    }
  },
  mounted () {
  },
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  methods: {
    // 点击其他设置
    notChooseAttr() {
      this.isAttr = false
    },
    // 点击客户属性
    chooseAttr() {
      this.isAttr = true
    },
    knows() {
    },
    // 保存
    save() {
      for (let item of this.ruleForm.canDo) {
        this.wechat_only = 1
        this.is_share = 1
        if (item === '访问页面时请求授权') {
          this.authorization = 1
        }
        if (item === '每个用户限填一次') {
          this.is_once = 1
        }
      }
      if (this.ruleForm.isVerifyMobile === 1) {
        for (let i = 0; i < this.attrPhoneArray.length; i++) {
          if (this.attrPhoneArray[i].identity === 'mobile') {
            this.attrPhoneArray.splice(i + 1, 0, {
              name: '手机验证',
              label: '手机验证',
              identity: 'verify_code',
              type: 'input'
            })
            i = i + 1
          }
        }
      }
      let id = this.$route.query.id
      editWePage(id, this.titleName, this.phoneImg, this.ruleForm.bindPublic, this.wechat_only, this.is_share, this.authorization, this.is_once, this.ruleForm.customerSource, this.ruleForm.sourceDesc, this.ruleForm.isVerifyMobile, 0, this.attrPhoneArray).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '编辑成功')
          router.push('/home/micro-page')
        } else {
          _g.toastMsg('success', res.data.error)
        }
      })
    },
    // 发布
    publish() {
      for (let item of this.ruleForm.canDo) {
        this.wechat_only = 1
        this.is_share = 1
        if (item === '访问页面时请求授权') {
          this.authorization = 1
        }
        if (item === '每个用户限填一次') {
          this.is_once = 1
        }
      }
      if (this.ruleForm.isVerifyMobile === 1) {
        for (let i = 0; i < this.attrPhoneArray.length; i++) {
          if (this.attrPhoneArray[i].identity === 'mobile') {
            this.attrPhoneArray.splice(i + 1, 0, {
              name: '手机验证',
              label: '手机验证',
              identity: 'verify_code',
              type: 'input'
            })
            i = i + 1
          }
        }
      }
    },
    // 跳转到第一页
    toFirst() {
      this.secondContent = false
      this.firstContent = true
      this.thirdContent = false
    },
    // 第三步跳转到第二步
    thirdToSecond() {
      this.secondContent = true
      this.firstContent = false
      this.thirdContent = false
    },
    // 跳转到第三步
    toThird() {
      this.$refs.ruleForm.validate((pass) => {
        if (pass) {
          this.secondContent = false
          this.firstContent = false
          this.thirdContent = true
        }
      })
    },
    // 第一步跳到第二步
    firstToSecond() {
      if (this.titleName === '') {
        _g.toastMsg('error', '请输入页面标题')
        return
      }
      if (this.phoneImg === '') {
        _g.toastMsg('error', '请上传图片')
        return
      }
      if (this.attrPhoneArray.length === 0) {
        _g.toastMsg('error', '请添加属性')
        return
      }
      this.secondContent = true
      this.firstContent = false
      this.thirdContent = false
    },
    // 设置为必填
    setMustWrite(item) {
      this.$confirm('确认设置该属性为?', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '必填',
        cancelButtonText: '非必填',
        type: 'warning'
      }).then(() => {
        item.itemMustWrite = true
      }).catch(action => {
        if (action === 'cancel') {
          item.itemMustWrite = false
        }
      })
    },
    // 删除对应的显示在手机端的属性
    deleteAttrItemPhone(item, index) {
      this.$confirm('确认删除该属性?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        for (let one of this.attrs) {
          if (one.identity === item.identity) {
            one.choosed = false
          }
        }
        this.attrPhoneArray.splice(index, 1)
        this.attrPhoneArrayCoby.splice(index, 1)
      }).catch((error) => {
      })
    },
    // 隐藏手机模态层
    hideModel(item) {
      item.itemShowModel = false
    },
    // 显示出手机模态层
    showModel(item) {
      item.itemShowModel = true
    },
    // 添加属性到右侧视图
    addAttr(item) {
      this.$confirm('确认添加该属性?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.attrPhoneArrayCoby.length === 0) {
          item.choosed = true
          this.attrPhoneArrayCoby.push(item)
          this.attrPhoneArray = JSON.parse(JSON.stringify(this.attrPhoneArrayCoby))
        } else {
          for (let one of this.attrPhoneArrayCoby) {
            if (one.identity === item.identity) {
              _g.toastMsg('error', '该属性已存在，请勿重复添加')
              return
            }
          }
          item.choosed = true
          this.attrPhoneArrayCoby.push(item)
          this.attrPhoneArray = JSON.parse(JSON.stringify(this.attrPhoneArrayCoby))
        }
      }).catch((error) => {
      })
    },
    // 打开修改页面标题弹窗
    openEditTitle() {
      this.editTitleDialog = true
    },
    // 修改页面标题
    editTitle() {},
    // 切换图片
    handleAvatarSuccess(res, file) {
      _g.toastMsg('success', '上传成功')
      this.phoneImg = res.data.path
    },
    beforeAvatarUpload(file) {
      _g.toastMsg('success', '正在上传')
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG && !isPNG) {
        _g.toastMsg('上传图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        _g.toastMsg('上传图片大小不能超过 2MB!')
      }
      return (isJPG && isLt2M) || (isPNG && isLt2M)
    },
    // 请求客户属性列表
    load() {
      let modelId = this.$route.query.modelId
      // 获取属性列表
      let getAttr = getCusAttrList(modelId)
      // 获取公众号列表
      let getPublic = getWechatPublicListAll()
      // 获取客户来源列表
      let getCustomerSource = getCustomerSourceListForWepage()
      // 获取详情回显数据
      let id = this.$route.query.id
      let getWePageDetails = getWePageDetail(id)
      Promise.all([getAttr, getPublic, getCustomerSource, getWePageDetails]).then(res => {
        // 处理属性获取
        if (res[0].data.code == 200) {
          let data = res[0].data.result
          for (let i in data) {
            if (data[i].isInner === 1) {
              data.splice(i, 1)
            }
            if (data[i].isNormal === 1) {
              this.attrs.push(data[i])
            }
          }
          for (let i in this.attrs) {
            this.attrs[i].label = this.attrs[i].name
            this.attrs[i].val = ''
            this.attrs[i].choosed = false
            this.attrs[i].itemShowModel = false
            this.attrs[i].itemMustWrite = false
          }
        }
        // 处理获取的公众号列表
        if (res[1].data.code === 0) {
          for (let one of res[1].data.data.list) {
            if (one.is_disable === 1) {
              one.disabled = true
            }
          }
          this.publics = res[1].data.data.list
        }
        // 处理获取的客户来源列表
        if (res[2].data.code === 0) {
          this.sources = res[2].data.data.list
        }
        // 处理详情回显数据
        if (res[3].data.code === 0) {
          this.tagsArray = res[3].data.data.tags
          let data = res[3].data.data
          // 循环显示被选中的
          // 循环去掉手机验证
          for (let i in data.identity) {
            if (data.identity[i].identity === 'verify_code') {
              data.identity.splice(i, 1)
            }
          }
          for (let item of this.attrs) {
            for (let one of data.identity) {
              one.itemShowModel = false
              one.label = one.name
              if (item.identity === one.identity) {
                item.choosed = true
                one.type = item.type
                if (one.is_require === 1) {
                  one.itemMustWrite = true
                } else {
                  one.itemMustWrite = false
                }
              }
            }
          }
          this.attrPhoneArrayCoby = data.identity
          this.attrPhoneArray = JSON.parse(JSON.stringify(this.attrPhoneArrayCoby))
          // 回显其他
          this.phoneImg = data.cover_img
          this.titleName = data.name
          this.ruleForm.bindPublic = data.public_id
          this.ruleForm.admin_title = data.admin_title
          this.ruleForm.link = data.redirect_url
          this.ruleForm.tips = data.return_msg
          this.ruleForm.submitLimit = data.submit_limit
          if (data.is_share === 0) {
            this.ruleForm.canDo.push('禁止分享')
          }
          if (data.authorization === 1) {
            this.ruleForm.canDo.push('访问页面时请求授权')
          }
          if (data.is_once === 1) {
            this.ruleForm.canDo.push('每个用户限填一次')
          }
          this.ruleForm.customerSource = data.source_id
          this.ruleForm.sourceDesc = data.source_content
          this.ruleForm.isVerifyMobile = data.is_send_sms
        }
      })
    }
  },
  components: {
    tagsTemplate
  },
  created() {
    this.load()
  }
}
</script>

<style scoped>
.radio-content{
  height: auto;
  padding-top: 20px;
  width: 90%;
}
.radio-name{
  position: absolute;
  top: 0;
  left: 5%;
  width: 90%;
  font-size: 10px;
  height: 20px;
  line-height: 20px;
  color: #999;
  text-align: left;
}
.checkbox-name{
  position: absolute;
  top: 0;
  left: 5%;
  width: 90%;
  font-size: 10px;
  height: 20px;
  line-height: 20px;
  color: #999;
  text-align: left;
}
.ele-div{
  height: auto;
  line-height: 40px;
  padding-top: 10px;
}
.publish-save-content{
  width: 300px;
  margin: 50px auto 0;
  border-radius: 4px;
  background: #FAFAFC;
  padding-bottom: 20px;
  padding-top: 80px;
}
.operation-tips{
  height: 40px;
  background: #699EFC;
  border-radius: 4px 4px 0 0;
  line-height: 40px;
  text-align: center;
  color: #fff;
}
.micro-page-add{
  width: calc(100% - 40px);
  min-height: 100%;
  margin: 20px auto 0;
  background-color: #F0F2F5;
}
.steps{
  width: 100%;
  height: 61px;
  background: #fff;
  margin: 0 auto 20px;
  padding-top: 59px;
}
.line{
  width: 600px;
  height: 1px;
  background: #c3c3c3;
  position: relative;
  margin: 0 auto;
}
.line-one{
  width: 300px;
  height: 1px;
  background: #c3c3c3;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.line-two{
  width: 300px;
  height: 1px;
  background: #c3c3c3;
  position: absolute;
  left: 300px;
  top: 0;
  z-index: 1;
}
.first-step{
  width: 60px;
  height: 60px;
  background: #c3c3c3;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 60px;
  position: absolute;
  left: -30px;
  top: -30px;
  z-index: 2;
}
.second-step{
  width: 60px;
  height: 60px;
  background: #c3c3c3;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 60px;
  position: absolute;
  left: 270px;
  top: -30px;
  z-index: 2;
}
.third-step{
  width: 60px;
  height: 60px;
  background: #c3c3c3;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 60px;
  position: absolute;
  right: -30px;
  top: -30px;
  z-index: 2;
}
.step-active{
  background: #679CFF;
}
.top-nav {
  width: 300px;
  height: 50px;
}
.left-title {
  width: 150px;
  float: left;
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  background: #fff;
  color: #333;
  font-weight: bold;
  cursor: pointer;
}
.isAttr{
  background: #679CFF;
  color: #fff;
}
.nav-tips{
  height: 14px;
  font-size: 12px;
  color: #999;
  line-height: 14px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.nav-tips span{
  color: #679CFF;
}
.attr-item{
  width: 120px;
  float: left;
  height: 40px;
  border: 1px solid #999;
  border-radius: 4px;
  text-align: center;
  line-height: 40px;
  margin: 7px 14px 0;
  color: #999;
  font-size: 14px;
  position: relative;
  cursor: pointer;
}
.other-set div{
  width: 120px;
  float: left;
  height: 40px;
  border: 1px solid #999;
  border-radius: 4px;
  text-align: center;
  line-height: 40px;
  margin: 7px 14px 0;
  color: #999;
  font-size: 14px;
  position: relative;
  cursor: pointer;
}
.attr-item i{
  display: block;
  border: 1px solid #999;
  border-radius: 50%;
  width: 10px;
  height: 12px;
  text-align: center;
  padding-right: 2px;
  line-height: 14px;
  position: absolute;
  top: 14px;
  right: 10px;
}
.main-content {
  width: 100%;/*calc(100% - 20px);*/
  margin-top: 20px;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  background-color: #F0F2F5;
}
.left-choose {
  width: 386px;
  /*width: 30%;*/
  height: 988px;
  background: #fff;
  padding-left: 10px;
  padding-right: 10px;
}
.right-show {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.phone-content{
  margin: 50px auto;
  width: 400px;
  height: 758px;
  background: url("../../assets/images/mobile_phone_frame.png") no-repeat center center;
  background-size: 100% 100%;
  padding-top: 70px;
}
.show-content {
  width: 320px;
  height: 681px;
  margin-left: 40px;
  overflow: auto;
  overflow-x: hidden;
}
.top-title{
  width: 100%;
  height: 35px;
  padding-top: 5px;
  background: #FFF;
  margin-bottom: 10px;
}
.top-title div {
  width: 100%;
  height: 30px;
  margin: 0 auto;
  background: #fff;
  border-radius: 4px;
  color: #999;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}
.top-title span {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.avatar-uploader-phone{
  width: 100%;
  height: auto;
  cursor: pointer;
}
.defaultPhoneImg, .useNowPhoneImg{
  display: block;
  width: 320px;
  height: 120px;
  border-top: 1px solid #f1f1f1;
  border-bottom: 1px solid #f1f1f1;
}
.useNowPhoneImg{
  width: 100%;
  height: auto;
  display: block;
}
.submit-btn{
  width: 90%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #fff;
  background: #1890FF;
  border-radius: 2px;
  margin: 10px auto;
}
.choosed, .choosed i{
  border: 1px solid #1890FF;
  color: #1890FF;
}
.attr-phone-item{
  position: relative;
  margin-top: 10px;
}
.item-model{
  background: #000;
  opacity: 0.6;
  position: absolute;
  left: 5%;
  right: 5%;
  bottom: 0;
  top: 0;
  border-radius: 2px;
  display: flex;
  z-index: 100;
  align-items: center;
  justify-content: space-around;
}
.item-model div{
  width: 80px;
  height: 40px;
  color: #fff;
  cursor: pointer;
  text-align: center;
}
.item-model div:hover,.item-model div:hover i{
  color: #1890FF;
}
.item-model div i{
  display: block;
  width: 80px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  color: #fff;
}
.must-write{
  width: 5%;
  height: 30px;
  padding-top: 10px;
  position: absolute;
  left: 0;
  top: 3px;
  font-size: 20px;
  color: red;
}
.demo-ruleForm{
  width: 300px;
  margin: 20px auto;
}
.third-content {
  margin-top: -20px;
  background-color: #fff;
  height: 100%;
}
.third-content p span{
  color: red;
}
.operation-content{
  width: 300px;
  height: 40px;
  margin: 0 auto;
}
.bottom-pre{
  width: 200px;
  height: 40px;
  margin: 100px auto 0;
}
.description-date{
  width: 76%;
  color: #1890FF;
  padding-left: 24%;
  text-align: left;
}
.text-align-left{
  text-align: left;
}
.date-type{
  width: 203px;
  display: flex;
  justify-content: space-between;
}
.date-type .dateChoose{
  border: 1px solid #1890FF!important;
  color: #1890FF!important;
}
.date-type div{
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #666;
  border: 1px solid #e5e5e5;
  cursor: pointer;
}
.date-type div:first-child{
  border-right: none;
}
::-webkit-scrollbar
{
  width: 6px;  /*滚动条宽度*/
  height: 16px;  /*滚动条高度*/
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;  /*滚动条的背景区域的圆角*/
  background-color: #f5f5f5;/*滚动条的背景颜色*/
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb
{
  border-radius: 10px;  /*滚动条的圆角*/
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #ccc;  /*滚动条的背景颜色*/
}
.addSelectItem{
  width: 90%;
  height: 30px;
  line-height: 30px;
  color: #1890FF;
  text-align: right;
  cursor: pointer;
  padding-right: 10%;
}
.removeSelectItem{
  width: 90%;
  height: 30px;
  line-height: 30px;
  color: red;
  text-align: right;
  cursor: pointer;
  padding-right: 10%;
}
.addMore{
  height: 300px;
  overflow: auto;
}
.normal{
  height: auto;
  overflow: hidden;
}
.tabs{
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
}
.tabs div{
  width: 82px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #666;
  border:1px solid #e5e5e5;
  border-left: none;
  cursor: pointer;
}
.tabs div:first-child{
  border: 1px solid #e5e5e5;
}
.tabs .type-select{
  border:1px solid #1890FF!important;
  color: #1890FF;
}
.tabs .edit-type-select{
  border:1px solid #1890FF!important;
  color: #1890FF;
  background: #ccc!important;
}
.addAttr{
  display: block;
  padding: 0 15px;
  height: 30px;
  background: #1890FF;
  color: #fff;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
  border-radius: 15px;
  float: right;
  margin-top: 5px;
  cursor: pointer;
}
.tag-span-look {
  display: inline-block;
  background-color: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 5px;
  height: 20px;
  line-height: 20px;
  padding: 5px;
  margin: 5px;
  color: #c0c4cc;
}
.tags-content-look {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>
